const getDiffColors = ({
  positiveDeltaIsGood,
  diff,
}: {
  positiveDeltaIsGood?: boolean;
  diff: number;
}) => {
  if (positiveDeltaIsGood || positiveDeltaIsGood === undefined) {
    if (diff >= 0) {
      return {
        textColor: 'var(--color-status-success)',
        iconBackgroundColor: 'var(--color-status-success-bg)',
      };
    }
    return {
      textColor: 'var(--color-status-danger)',
      iconBackgroundColor: 'var(--color-status-danger-bg)',
    };
  }

  if (diff >= 0) {
    return {
      textColor: 'var(--color-status-danger)',
      iconBackgroundColor: 'var(--color-status-danger-bg)',
    };
  }
  return {
    textColor: 'var(--color-status-success)',
    iconBackgroundColor: 'var(--color-status-success-bg)',
  };
};

export default getDiffColors;
